__turbopack_context__.v({
  "input": "input-module-scss-module__yRB76W__input",
  "input--with-leading-icon": "input-module-scss-module__yRB76W__input--with-leading-icon",
  "input--with-trailing-icon": "input-module-scss-module__yRB76W__input--with-trailing-icon",
  "input--without-label": "input-module-scss-module__yRB76W__input--without-label",
  "input__icon": "input-module-scss-module__yRB76W__input__icon",
  "input__icon--leading": "input-module-scss-module__yRB76W__input__icon--leading",
  "input__icon--trailing": "input-module-scss-module__yRB76W__input__icon--trailing",
  "input__label": "input-module-scss-module__yRB76W__input__label",
  "wrapper": "input-module-scss-module__yRB76W__wrapper",
});
